import { pathwaysUrls, toolkitUrls } from '@/util/links'
import type { StandardDetail } from '@/standards/standard_types'

export type StandardGroup = {
  standardSetCode: string
  standards: StandardDetail[]
}

// Sets migrated to Pathways are edited there; the rest still use the toolkit standard editor.
export function standardEditLink(standard: StandardDetail, pathwaysStandardSets: string[]): string {
  if (pathwaysStandardSets.includes(standard.standard_set_code)) {
    return pathwaysUrls.editStandard(standard.standard_set_code, standard.standard_long_ref)
  }
  if (!standard.uuid) {
    return ''
  }
  return toolkitUrls.editorLinks.editStandard(standard.uuid)
}
